import { exists } from '@/api'

export interface BatchStatisticsReferenceConditionListItem {
  dateFrom: string
  dateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  isAllBranchOnly: boolean
  isOutputReference: boolean
  isOutputEvent: boolean
  memo: string
  batchType: string
}

export function BatchStatisticsReferenceConditionListItemFromJSON(
  json: any
): BatchStatisticsReferenceConditionListItem {
  const resp = JSON.parse(json)

  return {
    dateFrom: exists(resp, 'date_from') ? resp.date_from : '',
    dateTo: exists(resp, 'date_to') ? resp.date_to : '',
    branchCodeFrom: exists(resp, 'branch_code_from')
      ? resp.branch_code_from
      : '',
    branchCodeTo: exists(resp, 'branch_code_to') ? resp.branch_code_to : '',
    isAllBranchOnly: exists(resp, 'is_all_branch_only')
      ? resp.is_all_branch_only
      : false,
    isOutputReference: exists(resp, 'is_output_reference')
      ? resp.is_output_reference
      : false,
    isOutputEvent: exists(resp, 'is_output_event')
      ? resp.is_output_event
      : false,
    memo: resp.memo,
    batchType: resp.batch_type
  }
}
